import { Link } from 'react-router-dom';
const HotelTabs = (props) => {
    return (
            <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
                <li className="nav-item" role="presentation">
                    <Link to={"/hotel/search"} className={props.pageName === "SEARCH" ? "nav-link active bg-primary text-white" : "nav-link"}>SEARCH</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/hotel/bookings"} className={props.pageName === "HOTELBOOKING" ? "nav-link active bg-primary text-white" : "nav-link"}>BOOKINGS</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/hotelreport"} className={props.pageName === "HOTELREPORT" ? "nav-link active bg-primary text-white" : "nav-link"}>HOTEL REPORT</Link>
                </li>
            </ul>
    );
};

export default HotelTabs;